import { Icon, Link } from '@ztechapps/webui.util'
import React, { useRef } from 'react'
import { FilterContainer } from './FilterContainer'
import { useTableFilterContext } from './Context'

export const FilterButton = () => {
  const target = useRef<HTMLDivElement>(null)
  const { setShowFilterContainer, hasFilterValue } = useTableFilterContext()
  return (
    <>
      <div ref={target}>
        <Link onClick={() => setShowFilterContainer((e) => !e)}>
          <Icon name={hasFilterValue() ? 'filter' : 'bars'} />
        </Link>
      </div>
      <FilterContainer target={target} />
    </>
  )
}
